const DefaultContentTemplateSkeleton = () => {
  return (
    <div>
      <div className="my-8 h-96 animate-pulse rounded-2xl bg-gray-300"></div>

      <div className="mb-8 h-8 animate-pulse rounded-md bg-gray-300"></div>

      <div className="mb-2 h-4 w-1/4 animate-pulse rounded-md bg-gray-300"></div>
      <div className="mb-8 h-4 w-1/2 animate-pulse rounded-md bg-gray-300"></div>

      <div className="mb-8 h-4 animate-pulse rounded-md bg-gray-300"></div>
      <div className="mb-8 h-4 w-3/4 animate-pulse rounded-md bg-gray-300"></div>
      <div className="mb-8 h-4 w-2/4 animate-pulse rounded-md bg-gray-300"></div>

      <div className="mb-8 h-6 animate-pulse rounded-md bg-gray-300"></div>

      <div className="mb-8 h-4 animate-pulse rounded-md bg-gray-300"></div>
      <div className="mb-8 h-4 w-3/4 animate-pulse rounded-md bg-gray-300"></div>
      <div className="mb-8 h-4 w-2/4 animate-pulse rounded-md bg-gray-300"></div>

      <div className="mb-8 h-1 animate-pulse rounded-md bg-gray-300"></div>
    </div>
  );
};

export default DefaultContentTemplateSkeleton;
